import {registerRoute as workbox_routing_registerRoute} from '/opt/jsbuilds/builds/ascm-common/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/opt/jsbuilds/builds/ascm-common/node_modules/workbox-strategies/NetworkFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/opt/jsbuilds/builds/ascm-common/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/opt/jsbuilds/builds/ascm-common/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/jsbuilds/builds/ascm-common/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/cdn/ascm-common/js/@dojo/loader/loader.js",
    "revision": "f66a38c73e036053cd0d1f928cb24e38"
  },
  {
    "url": "/cdn/ascm-common/js/core-js/polyfill.js",
    "revision": "149d609e92b0f722f6318e724ee932bd"
  },
  {
    "url": "/cdn/ascm-common/js/main.369b290d347ad41451e1.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-CN_Calendar_mjs.c521a3234be1f3e371aa.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-TW_Calendar_mjs.011fb15a6a18d1e209d6.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-CN_Dialog_mjs.8836163214d7beec8704.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-TW_Dialog_mjs.c19a9ea00beb6e412c3c.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_ask-the-instructor_main_js.9cfb424dc06a9afe51a0.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_fr-CA_DateInput_js.ca761ab83fd081a23c9d.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-CN_DateInput_js.8632c47d2e642e582ccd.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-TW_DateInput_js.e7ab04a188764e62170f.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-CN_index_js.2907752cedd95c5e3a34.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-TW_index_js.e0b7deefe09e52a5bb43.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-CN_index_js.29a658fee9f9d4bc23f5.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-TW_index_js.aa90475ef89b28b4a2b3.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/packages_node_modules_holmescorp_search-widget_main_js.23f626dcbb680909058f.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/vendors-packages_node_modules_holmescorp_class-roster_main_js.0196765c8486de3d3d79.js",
    "revision": null
  },
  {
    "url": "/cdn/ascm-common/js/vendors-packages_node_modules_holmescorp_editor-widget_index_js.f0865a4fe18b0620f262.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(/.+\/$/, new workbox_strategies_NetworkFirst({ "cacheName":"ascm2024-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\/js\/sitestart\.js$/, new workbox_strategies_NetworkFirst({ "cacheName":"ascm2024-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.(?:jpg|jpeg|png|svg|ttf|woff|woff2|eot|ico)$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"ascm2024-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.css$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"ascm2024-site", plugins: [] }), 'GET');




